<template>
	<div class="gestione-schede-hub">
		<div class="admin-subnav-wrap">
			<button
				type="button"
				class="subnav-toggle"
				:class="{ open: isSubnavOpen }"
				aria-label="Apri sezioni admin"
				:aria-expanded="isSubnavOpen ? 'true' : 'false'"
				@click="isSubnavOpen = !isSubnavOpen"
			>
				<span class="fas fa-ellipsis-v"></span>
			</button>
			<div class="admin-subnav" :class="{ open: isSubnavOpen }">
				<router-link :to="{ name: 'admin.userstats' }" class="subnav-link">
					<span class="fas fa-chart-line"></span>
					<span>Statistiche</span>
				</router-link>
				<router-link :to="{ name: 'admin.ranking' }" class="subnav-link">
					<span class="fas fa-trophy"></span>
					<span>Ranking</span>
				</router-link>
				<router-link :to="{ name: 'admin.analytics' }" class="subnav-link">
					<span class="fas fa-chart-pie"></span>
					<span>Analytics</span>
				</router-link>
				<router-link :to="{ name: 'admin.runningprograms' }" class="subnav-link">
					<span class="fas fa-running"></span>
					<span>Gestione schede</span>
				</router-link>
				<router-link :to="{ name: 'admin.reportprove' }" class="subnav-link">
					<span class="fas fa-clipboard-list"></span>
					<span>Report Prove</span>
				</router-link>
				<router-link :to="{ name: 'admin.challenge' }" class="subnav-link">
					<span class="fas fa-bolt"></span>
					<span>Challenge</span>
				</router-link>
				<router-link :to="{ name: 'admin.personaltraining' }" class="subnav-link">
					<span class="fas fa-calendar-check"></span>
					<span>Personal Training</span>
				</router-link>
			</div>
		</div>

		<section class="hero">
			<p class="eyebrow">Admin</p>
			<h2>Gestione schede</h2>
			<p class="lead">
				Scegli la categoria per gestire, creare e assegnare schede ai tuoi clienti.
			</p>
		</section>

		<section class="categories">
			<router-link
				v-for="cat in categories"
				:key="cat.name"
				:to="{ name: cat.routeName }"
				class="cat-card"
			>
				<span class="cat-icon">{{ cat.icon }}</span>
				<div class="cat-body">
					<h3>{{ cat.title }}</h3>
					<p>{{ cat.desc }}</p>
				</div>
				<span class="cat-arrow fas fa-chevron-right"></span>
			</router-link>
		</section>
	</div>
</template>

<script>
export default {
	name: 'GestioneSchedeAdmin',

	data() {
		return {
			isSubnavOpen: false,
			categories: [
				{
					routeName: 'admin.runningprograms.corsa',
					icon: '🏃',
					title: 'Schede corsa',
					desc: 'Gestisci e assegna programmi di corsa ai clienti.'
				},
				{
					routeName: 'admin.runningprograms.palestra',
					icon: '🏋️',
					title: 'Schede palestra',
					desc: 'Gestisci e assegna schede di allenamento in palestra.'
				},
				{
					routeName: 'admin.runningprograms.hyrox',
					icon: '⚡',
					title: 'Schede HYROX',
					desc: 'Gestisci e assegna programmi di preparazione HYROX.'
				}
			]
		}
	}
}
</script>

<style lang="stylus" scoped>
.gestione-schede-hub
	padding 1.5em 0 6em
	color light

.hero
	margin-bottom 1.5em

.eyebrow
	margin 0 0 0.5em
	color primary
	text-transform uppercase
	letter-spacing 0.14em
	font-size 0.75rem

h2
	margin 0 0 0.4em

.lead
	max-width 60rem
	color rgba(255, 255, 255, 0.72)
	line-height 1.6

.categories
	display grid
	grid-template-columns repeat(3, minmax(0, 1fr))
	gap 1em

.cat-card
	display flex
	align-items center
	gap 1em
	padding 1.4em 1.2em
	border 1px solid rgba(255, 255, 255, 0.08)
	border-radius 1em
	background rgba(255, 255, 255, 0.03)
	color light
	text-decoration none
	transition border-color 0.2s, background 0.2s, transform 0.2s

.cat-card:hover
	border-color rgba(255, 224, 16, 0.35)
	background rgba(255, 224, 16, 0.04)
	transform translateY(-2px)

.cat-icon
	font-size 2rem
	line-height 1
	flex-shrink 0

.cat-body
	flex 1

.cat-body h3
	margin 0 0 0.3em
	font-size 1.1rem

.cat-body p
	margin 0
	font-size 0.88rem
	color rgba(255, 255, 255, 0.62)
	line-height 1.5

.cat-arrow
	font-size 0.9rem
	color rgba(255, 224, 16, 0.5)
	flex-shrink 0
	transition transform 0.2s

.cat-card:hover .cat-arrow
	transform translateX(3px)

.admin-subnav-wrap
	position relative
	display flex
	justify-content flex-end
	margin-bottom 1em

.subnav-toggle
	width 42px
	height 42px
	border none
	border-radius 999px
	background rgba(255, 255, 255, 0.08)
	color primary
	cursor pointer

.subnav-toggle.open
	background rgba(255, 224, 16, 0.16)

.admin-subnav
	position absolute
	top calc(100% + 0.5em)
	right 0
	z-index 30
	min-width 220px
	display none
	flex-direction column
	padding 0.5em
	border 1px solid rgba(255, 255, 255, 0.08)
	border-radius 0.9em
	background darker
	box-shadow 0 10px 30px rgba(0, 0, 0, 0.28)

.admin-subnav.open
	display flex

.subnav-link
	display flex
	align-items center
	gap 0.7em
	padding 0.8em 0.9em
	border-radius 0.75em
	color light
	text-decoration none

.subnav-link:hover,
.subnav-link.router-link-exact-active
	background rgba(255, 255, 255, 0.08)
	color primary

@media (max-width: 700px)
	.categories
		grid-template-columns 1fr
</style>
